var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNebius(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3333 7.53622V29.2323C30.3333 29.2323 35.5 28.9198 35.5 23.013V7.53622H30.3333ZM9.66667 32.9756V11.2795C9.66667 11.2795 4.5 11.5921 4.5 17.5001V32.9743L9.66667 32.9756Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5776 25.883L19.078 10.9384C18.0136 8.5204 16.2776 7.15898 13.8118 7.15898C11.3473 7.15898 9.66431 9.14815 9.66431 11.2794C9.66431 11.2794 12.7708 10.8493 14.4176 14.6287L20.9225 29.5733C21.9829 31.9887 23.7228 33.3527 26.186 33.3527C28.6466 33.3527 30.3336 31.3622 30.3336 29.2323C30.3336 29.2323 27.2258 29.6637 25.5776 25.883Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNebius);
export default __webpack_public_path__ + "static/media/nebius.3a27cb01f081f3f2cd596a91664c64c4.svg";
export { ForwardRef as ReactComponent };